import { TKV2_ORDERS_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrdersAPIError,
  GetTkv2OrdersAPIVariables,
  fetchGetTkv2OrdersAPI,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDERS_API.GET;

export const useGetTkv2OrdersAPI = (
  variables: GetTkv2OrdersAPIVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrdersAPIError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrdersAPIError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2OrdersAPIError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders',
      operationId: 'getTkv2OrdersAPI',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetTkv2OrdersAPI({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
